import { render, staticRenderFns } from "./noteRecords.vue?vue&type=template&id=b8f86dd2&scoped=true&"
import script from "./noteRecords.vue?vue&type=script&lang=js&"
export * from "./noteRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f86dd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8f86dd2')) {
      api.createRecord('b8f86dd2', component.options)
    } else {
      api.reload('b8f86dd2', component.options)
    }
    module.hot.accept("./noteRecords.vue?vue&type=template&id=b8f86dd2&scoped=true&", function () {
      api.rerender('b8f86dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/complaint/dailog/noteRecords.vue"
export default component.exports